import React from 'react'
import { useActions } from 'kea'
import PropTypes from 'prop-types'
import sceneLogic from '~/scenes/search/logic'

import './styles.scss'

function Buckets ({ buckets }) {
  const { triggerLocationChange } = useActions(sceneLogic)

  const handleClick = (e, bucket) => {
    if (buckets.type !== 'country') {
      e.preventDefault()
      triggerLocationChange(bucket.url)
    }
  }

  return (
    <div className='grid'>
      <div className='col-1-1 buckets'>
        <h2>{buckets.title}</h2>
        <ul>
          {buckets.buckets.map(bucket => (
            <li key={bucket.url}>
              <a href={bucket.url} onClick={e => handleClick(e, bucket)} title={bucket.description}>
                {bucket.title}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}

Buckets.prototype = {
  buckets: PropTypes.object.isRequired
}

export default React.memo(Buckets)
